import { Component } from '@angular/core';
import { ModalController,NavController, Platform, NavParams, ViewController } from 'ionic-angular';
import { datos } from '../../providers/datos';
import { Detalle } from '../detalle/detalle';
import moment from 'moment';




declare var cordova:any;
declare var document:any;
declare var window:any;
declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'direcciones',
  templateUrl: 'direcciones.html',
})
export class direcciones {

menu="hoy";
hora:any;
fecha:any;
item= {
"id":"",
"nombre":"",
"cantidad":1,
"valor":0,
"fecha":"",
"hora":"",
"img":"assets/images/servicios/manos.jpg",
"des":"sasasasasas"
};

  constructor(   
   public viewCtrl: ViewController,
   public params: NavParams,
   private datos:datos,

    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController
  



   ) {

  //  let temp =   this.navParams.get('item');
    // this.producto= this.params.get('producto');
    //  this.item= temp;
      
    //  console.log( temp);

  }

  ionViewDidLoad() {
    // var _hora = moment(hora,'HH:mm').locale('es');
    // var actual = moment(moment().format('HH:mm:ss'),'HH:mm').locale('es');


    this.hora = String(moment().format('HH:mm'));
    this.fecha = String(moment().format('YYYY-MM-DD'));

    console.log(this.fecha);
    // let dif = _hora.diff(actual,'minutes');

    this.item.hora=String(this.hora);
    this.item.fecha=String(this.fecha);


  }


  putUbcacion(t,d){

    if(!t || !d ){
      this.datos.Toast("DATO NO VÁLIDO",1000);
      return;

    }
    let data = 	{nombre:t, referencia:d ,lat:"", long:"", id:""};
  
    this.datos.direcciones.push(data);

    this.datos.pedido.direccion.text=t;
        this.datos.pedido.pago.id="0";

        this.datos.Toast("REGISTRADO",2000);
        setTimeout(() => {
          this.cancel();
        }, 2000);
    
  }




  detalle() {

    setTimeout(() => {
      this.cancel();
    }, 50);


    
    console.log("detalle");

  
    
      this.navCtrl.push(Detalle,{ });
      
   


    // let modal = this.modalCtrl.create(Detalle,{},{cssClass: "detalle"});
    // modal.onDidDismiss(data => {
  
    //   if (data.dato) {
        
    //      }
    //      console.log(JSON.stringify(data));
    //    });
    // modal.present();
  
  }




  add(){
 


  }

  dismiss(){
    this.viewCtrl.dismiss();

  }

cancel(){
  
    this.viewCtrl.dismiss({dato:0});

}





}


// WEBPACK FOOTER //
// ./src/pages/direcciones/direcciones.ts